import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { useLoggedInEmployeeId } from '~/components/Auth';
import { ListWidgetComponentFactory } from '~/components/MyWorkspace/ListWidget';
import { useModulesConfig } from '~/data/company';
import { People } from '~/services/Http';
import { useGetEmployeeAssignedTasks } from '~/services/Http/hooks';
import { AppModules } from '~/services/Permissions';

import { WidgetProps } from '../../data/widgets';

import { Task } from './components/Task';
import { TaskInfo } from './components/TaskInfo';

export interface Props extends WidgetProps {}

const MyTasksWidgetComponent = ListWidgetComponentFactory({
  ListItemComponent: Task,
  getIdentifier: (item: People.TaskDto) => item.id,
  ListItemInfoComponent: TaskInfo,
  dataCy: 'my-tasks-widget',
});

export const getEmployeeAssignedTasksReqParams = {
  employeeId: 'me',
};

export const MyTasksWidget: React.FC<Props> = ({ title }) => {
  const { t } = useTranslation();

  const employeeId = useLoggedInEmployeeId();
  const { isModuleEnabled } = useModulesConfig();

  const {
    data: tasks,
    loading,
    failedToLoad,
  } = useGetEmployeeAssignedTasks(getEmployeeAssignedTasksReqParams);

  return (
    <MyTasksWidgetComponent
      title={title || t('myTasks')}
      noDataMessage={t('noTasks')}
      data={tasks}
      loading={loading}
      failedToLoad={failedToLoad}
      addListItemUrl={
        isModuleEnabled(AppModules.COLLABORATION)
          ? `/page-ui2-redirect?empId=${employeeId}&area=collaboration`
          : undefined
      }
    />
  );
};
